import Modal from 'react-bootstrap/Modal';


function ModalCenter({show, setShow,children, title, headerColor,size}) {

  return (
    <Modal
    size={size || 'lg'}
    show={show}
    onHide={() => setShow(false)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header style={{background:headerColor || 'white'}} closeButton>
        <Modal.Title id="contained-modal-title-vcenter" style={{fontSize:17}}>
         <b>{title}</b>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {children}
      </Modal.Body>
    </Modal>
  );
}

export default ModalCenter;